import { HttpErrorResponse } from "@angular/common/http";
import { IExtractResponse, IContentResponse, IErrorResponse } from "../../interfaces/extract.interface";

const ActionTypes = {
  EXTRACT_PREVIEW: '[Extract] Extract Preview',
  EXTRACT_PREVIEW_SUCCESS: '[Extract] Extract Preview Success',
  EXTRACT_PREVIEW_FAIL: '[Extract] Extract Preview Fail',

  EXTRACT_PREVIEW_STREAM: '[Extract] Extract Preview Stream',

  EXTRACT_DOWNLOAD: '[Extract] Extract Download',
  EXTRACT_DOWNLOAD_SUCCESS: '[Extract] Extract Download Success',
  EXTRACT_DOWNLOAD_FAIL: '[Extract] Extract Download Fail',

  EXTRACT_DOWNLOAD_STREAM: '[Extract] Extract Download Stream',

  GET_EXTRACT_NAME_FROM_HASH: '[Extract] Get Extract Name From Hash',
  GET_EXTRACT_NAME_FROM_HASH_SUCCESS: '[Extract] Get Extract Name From Hash Success',
  GET_EXTRACT_NAME_FROM_HASH_FAIL: '[Extract] Get Extract Name From Hash Fail',

  UPDATE_EXTRACT_NAME: '[Extract] Update Extract Name',
  UPDATE_EXTRACT_NAME_SUCCESS: '[Extract] Update Extract Name Success',
  UPDATE_EXTRACT_NAME_FAIL: '[Extract] Update Extract Name Fail',

  GET_ALL_QUERIES: '[Extract] Get All Queries',
  GET_ALL_QUERIES_SUCCESS: '[Extract] Get All Queries Success',
  GET_ALL_QUERIES_FAIL: '[Extract] Get All Queries Fail',

  GET_QUERY_DETAILS: '[Extract] Get Query Details',
  GET_QUERY_DETAILS_SUCCESS: '[Extract] Get Query Details Success',
  GET_QUERY_DETAILS_FAIL: '[Extract] Get Query Details Fail',
}

export class ExtractPreview {
  static type = ActionTypes.EXTRACT_PREVIEW;
}

export class ExtractPreviewSuccess {
  static type = ActionTypes.EXTRACT_PREVIEW_SUCCESS;

  constructor(public payload: IExtractResponse) {}
}

export class ExtractPreviewFail {
  static type = ActionTypes.EXTRACT_PREVIEW_FAIL;

  constructor(public payload: HttpErrorResponse) {}
}

export class ExtractPreviewStream {
  static type = ActionTypes.EXTRACT_PREVIEW_STREAM;

  constructor(public payload: string) {}
}

export class ExtractDownload {
  static type = ActionTypes.EXTRACT_DOWNLOAD;
}


export class ExtractDownloadSuccess {
  static type = ActionTypes.EXTRACT_DOWNLOAD_SUCCESS;

  constructor(public payload: IExtractResponse) {}
}

export class ExtractDownloadFail {
  static type = ActionTypes.EXTRACT_DOWNLOAD_FAIL;

  constructor(public payload: HttpErrorResponse) {}
}

export class ExtractDownloadStream {
  static type = ActionTypes.EXTRACT_DOWNLOAD_STREAM;

  constructor(public payload: string) {}
}

export class GetExtractNameFromHash {
  static type = ActionTypes.GET_EXTRACT_NAME_FROM_HASH;
}

export class GetExtractNameFromHashSuccess {
  static type = ActionTypes.GET_EXTRACT_NAME_FROM_HASH_SUCCESS;

  constructor(public payload: IContentResponse) {}
}

export class GetExtractNameFromHashFail {
  static type = ActionTypes.GET_EXTRACT_NAME_FROM_HASH_FAIL;

  constructor(public payload: IErrorResponse) {}
}

export class UpdateExtractName {
  static type = ActionTypes.UPDATE_EXTRACT_NAME;

  constructor(public newName: string) {}
}

export class UpdateExtractNameSuccess {
  static type = ActionTypes.UPDATE_EXTRACT_NAME_SUCCESS;

  constructor(public payload: IContentResponse) {}
}

export class UpdateExtractNameFail {
  static type = ActionTypes.UPDATE_EXTRACT_NAME_FAIL;

  constructor(public payload: any) {}
}

export class GetAllQueries {
  static type = ActionTypes.GET_ALL_QUERIES;
}

export class GetAllQueriesSuccess {
  static type = ActionTypes.GET_ALL_QUERIES_SUCCESS;

  constructor(public payload: IContentResponse) {}
}

export class GetAllQueriesFail {
  static type = ActionTypes.GET_ALL_QUERIES_FAIL;

  constructor(public payload: any) {}
}

export class GetQueryDetails {
  static type = ActionTypes.GET_QUERY_DETAILS;

  constructor(public name: string) {}
}

export class GetQueryDetailsSuccess {
  static type = ActionTypes.GET_QUERY_DETAILS_SUCCESS;

  constructor(public payload: IContentResponse) {}
}

export class GetQueryDetailsFail {
  static type = ActionTypes.GET_QUERY_DETAILS_FAIL;

  constructor(public payload: any) {}
}